import axios from "axios";
import ErrorParser from '../../../helpers/services/error.parser';

const StationsService = {
  stations: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/stations",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
   mediavalues: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/stations/mediavalues",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  }, 
   measurementregimes: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/stations/measurement_regimes",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },   
   areaclassifications: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/stations/area_classifications",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },   
  networks: async function () {
    const requestData = {
      method: "get",
      url: "/api/management/stations/networks",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },  
  geom: async function (geom) {
    const requestData = {
      method: "post",
      url: "/api/management/stations/geom",
      data: { geom: geom }
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },    
  delete: async function (id) {
    const requestData = {
      method: "post",
      url: "/api/management/stations/delete",
      data: { id: id }
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  update: async function (stations) {
    const requestData = {
      method: "post",
      url: "/api/management/stations/update",
      data: stations
    };
    try {
      // debugger;
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  import: async function (formData) {
    const requestData = {
      method: "post",
      url: "/imports/stations",
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  }
};

export default StationsService;

